import { render, staticRenderFns } from "./TicketAdd.vue?vue&type=template&id=2b511a1d&"
import script from "./TicketAdd.vue?vue&type=script&lang=js&"
export * from "./TicketAdd.vue?vue&type=script&lang=js&"
import style0 from "./TicketAdd.vue?vue&type=style&index=0&id=2b511a1d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports